module.exports = __webpack_public_path__ + "img/placeholder-spring-commencement-23.0cf23a1d.jpg";